import BaseDataProvider from "./BaseDataProvider";
import BaseEventHandler from "./BaseEventHandler";
import BaseScreenProvider from "./BaseScreenProvider";

export const baseDataProvider = new BaseDataProvider();
export const baseEventHandler = new BaseEventHandler();
export const baseScreenProvider = new BaseScreenProvider();
